// @flow
import React, { useContext } from 'react';
import isEmpty from 'ramda/es/isEmpty';

import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';
import { DotsLoader } from 'app/common/components/Loader';

import SellPointsContext from './sell-points-context';


type Props = {
  className?: string,
  title: string,
}

const SellPointView = ({ className, title }: Props) => {
  const {
    loading,
    currentSellPoint,
    handleShowSelector,
  } = useContext(SellPointsContext);

  const sellPointTitle = currentSellPoint ? currentSellPoint.title : '';

  return (
    <div className={className}>
      {title}
      &nbsp;
      {loading || !currentSellPoint || isEmpty(currentSellPoint)
        ? <DotsLoader simple />
        : <PlainButtonAsLink onClick={handleShowSelector}>
          {sellPointTitle}
        </PlainButtonAsLink>}
    </div>
  );
};

export default SellPointView;
